import Phaser from 'phaser';

const radialTowerRasterAssets = ['tower-tesla', 'tower-nulificator'] as const;

const directionalTowerRasterAssets = [
  ['missile', 'missile-turret-base@2x.png', 'missile-turret-module@2x.png'],
  ['howitzer', 'howitzer-turret-base@2x.png', 'howitzer-turret-module@2x.png'],
  ['gatling', 'gatling-turret-base@2x.png', 'gatling-turret-module@2x.png'],
  ['aa', 'aa-turret-base@2x.png', 'aa-turret-module@2x.png'],
  ['goo', 'goo-turret-base@2x.png', 'goo-turret-module@2x.png'],
  ['chain', 'chain-turret-base@2x.png', 'chain-turret-module@2x.png'],
  ['gauss', 'gauss-turret-base@2x.png', 'gauss-turret-module@2x.png'],
  ['oil', 'oil-turret-base@2x.png', 'oil-turret-module@2x.png'],
] as const;

const enemyRasterAssets = [
  'enemy-ground-tiny', 'enemy-ground-small', 'enemy-ground-medium', 'enemy-ground-big',
  'enemy-air-tiny', 'enemy-air-small', 'enemy-air-medium', 'enemy-air-big',
] as const;

const buildingRasterAssets = [
  'building-silo', 'building-wall-factory', 'building-recycler', 'building-radar', 'building-laboratory',
] as const;

/** Loads clean-room top-down unit art; original reference pixels and assets are never used. */
export class BootScene extends Phaser.Scene {
  constructor() { super('boot'); }

  preload(): void {
    this.load.image('terrain-sand', 'assets/terrain/pale-sand.png');
    this.load.image('terrain-rock', 'assets/terrain/rust-rock.png');
    radialTowerRasterAssets.forEach((key) => this.load.image(key, `assets/units/${key}.png`));
    directionalTowerRasterAssets.forEach(([name, base, module]) => {
      this.load.image(`tower-${name}-base`, `assets/units/${base}`);
      this.load.image(`tower-${name}-module`, `assets/units/${module}`);
    });
    enemyRasterAssets.forEach((key) => this.load.image(key, `assets/units/${key}.png`));
    buildingRasterAssets.forEach((key) => this.load.image(key, `assets/units/${key}.png`));
  }

  create(): void { this.scene.start('battle'); }
}
